import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

function getInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "";
  if (trimmed.length === 1) return trimmed[0].toUpperCase();
  if (!trimmed.includes(" ")) {
    return `${trimmed[0].toUpperCase()}${trimmed[1].toLowerCase()}`;
  }
  const parts = trimmed.replace(/ +/g, " ").split(" ");
  return `${parts[0][0].toUpperCase()}${parts[1][0].toUpperCase()}`;
}

interface LetterAvatarProps {
  name: string;
  isOrg?: boolean;
  isLoading?: boolean;
  className?: string;
}

export function LetterAvatar({
  name,
  isOrg = false,
  isLoading = false,
  className,
}: LetterAvatarProps) {
  if (isLoading || !name) {
    return <Skeleton className={cn("size-10 rounded", className)} />;
  }

  return (
    <Avatar
      size="lg"
      className={cn(isOrg ? "rounded-md" : "rounded-full", className)}
    >
      <AvatarFallback
        className={cn(
          "text-lg font-semibold text-accent-foreground",
          isOrg
            ? "rounded-md bg-accent"
            : "rounded-full bg-info text-info-foreground",
        )}
      >
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
